/** `en-US` et `en` partagent les mêmes fiches. Tout le reste reste en français. */
export const catalogLanguage = (language) =>
  String(language || 'fr').toLowerCase().startsWith('en') ? 'en' : 'fr';

// Traductions des produits
export const productTranslations = {
  fr: {
    // Volume Profile Premium
    'volume-profile-premium': {
      name: 'Volume Profile Premium',
      description: 'Où le volume s’est échangé par prix : session, semaine ou mois — POC, value area, modes Standard / Buy-Sell / Delta',
      features: [
        "Profils session, semaine et mois ; résolution tick ou minute",
        "POC, value area (10 %–90 %), extensions des périodes précédentes",
        "Histogramme horizontal, couleurs, projections et libellés configurables"
      ]
    },
    // VWAP Premium
    'vwap-premium': {
      name: 'VWAP Premium',
      description: 'VWAP jour, semaine et mois avec bandes 1σ à 3σ et projection des VWAP des sessions précédentes',
      features: [
        "Trois VWAP (quotidienne, hebdomadaire, mensuelle)",
        "Bandes de déviation 1σ, 2σ et 3σ ; code couleur",
        "Projection des niveaux VWAP des sessions passées ; personnalisation complète"
      ]
    },
    // VWAP Lite
    'vwap-lite': {
      name: 'VWAP Lite',
      description: 'VWAP du jour, bandes 1σ et 2σ — l’essentiel sans multi-période',
      features: [
        "VWAP journalière avec réinitialisation à l'ouverture",
        "Bandes 1σ et 2σ, code couleur",
        "Interface épurée, personnalisation simple, impact léger sur les ressources"
      ]
    },
    // Volume Profile Lite
    'volume-profile-lite': {
      name: 'Volume Profile Lite',
      description: 'Volume Profile quotidien avec POC et value area — la version essentielle',
      features: [
        'Volume Profile journalier (session de trading)',
        'POC et value area ; affichage Standard',
        'Lecture support / résistance par le volume ; installation et mises à jour incluses'
      ]
    },
    // Trading Sessions
    'trading-sessions': {
      name: 'Trading Sessions',
      description: 'Tokyo, Londres, New York et chevauchements colorés sur le graphique — le contexte horaire immédiat',
      features: [
        'Sessions Tokyo/Asie, Londres/Europe, New York/US',
        'Mise en évidence des overlaps ; opacité réglable (0–10)',
        'Horaires et couleurs configurables (DST, instrument)'
      ]
    },
    // Asian Session Levels
    'asian-session-levels': {
      name: 'Asian Session Levels',
      description: 'Repères de la session asiatique prolongés sur la journée — Europe et US dans le même cadre',
      features: [
        'Niveaux clés de la session asiatique (extrêmes et repères configurables)',
        'Tracé des niveaux des sessions précédentes sur la session en cours',
        'Couleurs, horaires, labels et fenêtre de session ajustables'
      ]
    },
    // Enhanced Session Levels
    'enhanced-session-levels': {
      name: 'Enhanced Session Levels',
      description: 'IB, OR, hauts/bas de session et extensions — la structure du début de séance lisible d’un coup d’œil',
      features: [
        "Initial Balance, Opening Range et extremums de session tracés automatiquement",
        "Extensions IB de 100 % à 600 % (jusqu'à 6 niveaux)",
        "Zones, horaires, prémarket, couleurs et prix sur les niveaux — tout paramétrable"
      ]
    },
    // Risk/Reward
    'risk-reward': {
      name: 'Risk/Reward',
      description: 'Ratio risque/récompense sur le graphique avec jusqu’à 3 take profit — avant l’ordre',
      features: [
        "TP1, TP2, TP3 avec ratio calculé par niveau",
        "Lignes entrée, stop, objectifs ; zones risque / récompense",
        "Couleurs, styles et affichage conditionnel configurables"
      ]
    },
    // Open Levels
    'open-levels': {
      name: 'Alturion Open Levels',
      description: 'Opens jour/semaine/mois + OHLC des périodes passées (jusqu’à 10 jours/semaines, 12 mois)',
      features: [
        "Opens courants avec extension jusqu’à la barre actuelle",
        "OHLC 1–10 sessions/semaines, 1–12 mois ; extension configurable",
        "Styles de ligne, épaisseurs 0,5–5 px, thème Gold & Platinum, labels empilés",
        "Cinq groupes de paramètres, activation par niveau, rendu SharpDX"
      ]
    },
    // ORB
    'orb': {
      name: 'Alturion Open Range Breakout',
      description: 'Range d’ouverture tracé automatiquement, extensions 100–300 % et flèches de cassure',
      features: [
        "Haut, bas, milieu du range ; heures et durée paramétrables",
        "Extensions 100 %, 200 %, 300 % ; labels de prix",
        "Flèches haussières/baissières (aide visuelle) ; ranges des sessions passées en option",
        "Couleurs palette Alturion, styles et épaisseurs de lignes"
      ]
    },
    'bar-timer': {
      name: 'Bar Timer',
      description: 'Compte à rebours de barre NinjaTrader — timing de clôture lisible sur le graphique',
      features: [
        "Compte à rebours jusqu'à la clôture de la barre",
        'Affichage discret et personnalisable',
        'Compatible NinjaTrader 8'
      ]
    },
    'nypa': {
      name: 'NYPA',
      description: 'Deux zones de liquidité de la session US de la veille — support/résistance et breakouts optionnels',
      features: [
        'Identification des zones support et résistance',
        'Indication optionnelle du breakout de zone',
        'Alertes configurables ; horaires US selon votre fuseau'
      ]
    },
    'economic-calendar': {
      name: 'Economic Calendar',
      description: 'Calendrier macro intégré — fenêtre dédiée et lignes verticales à l’heure exacte sur le graphique',
      features: [
        'Filtres par période (aujourd’hui, demain, semaine) et par impact (étoiles)',
        'Lignes verticales sur le chart à l’heure de chaque annonce',
        'Couleurs et visibilité des événements configurables'
      ]
    },
    'account-locker': {
      name: 'Account Locker',
      description: 'Dashboard risque & décompte NT8 — règles, PnL live, peak et calendrier économique intégré',
      features: [
        'Règles : perte/gain journalier, max trades, max lots, horaires',
        'PnL trade en cours, réalisé du jour et peak (drawdown intraday)',
        'Lock manuel (jusqu’au lendemain ou durée définie) + calendrier intégré'
      ]
    },
    'footprint': {
      name: 'Footprint',
      description: 'Order flow tick-by-tick — Bid×Ask, delta, imbalances et profil par barre',
      features: [
        'Modes Bid×Ask, Delta, Volume et Volume Profile',
        'Imbalances diagonales et stacked zones',
        'POC, Value Area et stats delta par barre'
      ]
    },
    'tape-power-meter': {
      name: 'Tape Power Meter',
      description: 'Mesure la pression acheteur/vendeur du tape pour lire le flux en temps réel',
      features: [
        'Lecture de la pression du tape',
        'Visualisation temps réel du déséquilibre',
        'Paramètres adaptés au day trading futures'
      ]
    },
    'fair-value-gap': {
      name: 'Fair Value Gap',
      description: 'Détection automatique des Fair Value Gaps et suivi des zones non comblées',
      features: [
        'Détection automatique des FVG',
        'Suivi des gaps jusqu’à mitigation',
        'Affichage clair sur le graphique NT8'
      ]
    },
    'cumulative-delta': {
      name: 'Cumulative Delta',
      description: 'Flux acheteur/vendeur cumulé pour visualiser le déséquilibre dans le temps',
      features: [
        'Delta cumulé session / période',
        'Lecture du déséquilibre acheteur/vendeur',
        'Personnalisation des resets et couleurs'
      ]
    },
    'delta-profile': {
      name: 'Delta Profile',
      description: 'Distribution du delta par prix pour repérer où le flux s’est vraiment battu',
      features: [
        'Profil de delta par niveau de prix',
        'Identification des zones de conflit de flux',
        'Compatible analyse volume / order flow'
      ]
    },
    'big-trades': {
      name: 'Big Trades',
      description: 'Mise en évidence des gros prints pour repérer l’activité institutionnelle',
      features: [
        'Filtrage des gros trades par taille',
        'Marqueurs visuels sur le graphique',
        'Seuils adaptés par instrument'
      ]
    }
  },
  en: {
    // Volume Profile Premium
    'volume-profile-premium': {
      name: 'Volume Profile Premium',
      description: 'Volume-at-price by session, week, or month — POC, value area, Standard / Buy-Sell / Delta',
      features: [
        "Session, week, and month profiles; tick or minute resolution",
        "POC, value area (10%–90%), prior-period extensions",
        "Horizontal histogram, colors, projections, configurable labels"
      ]
    },
    // VWAP Premium
    'vwap-premium': {
      name: 'VWAP Premium',
      description: 'Daily, weekly, monthly VWAP with 1σ–3σ bands and projected prior-session VWAPs',
      features: [
        "Three VWAPs (daily, weekly, monthly)",
        "1σ, 2σ, and 3σ deviation bands with color coding",
        "Projected VWAP levels from past sessions; full customization"
      ]
    },
    // VWAP Lite
    'vwap-lite': {
      name: 'VWAP Lite',
      description: 'Day VWAP with 1σ and 2σ bands — essentials without multi-period VWAP',
      features: [
        "Daily VWAP reset at the open",
        "1σ and 2σ bands, color coding",
        "Clean UI, simple customization, light resource use"
      ]
    },
    // Volume Profile Lite
    'volume-profile-lite': {
      name: 'Volume Profile Lite',
      description: 'Daily Volume Profile with POC and value area — the essential build',
      features: [
        "Daily Volume Profile (trading session)",
        "POC and value area; Standard display",
        "Support/resistance read from volume; installation and updates included"
      ]
    },
    // Trading Sessions
    'trading-sessions': {
      name: 'Trading Sessions',
      description: 'Tokyo, London, New York, and overlaps shaded on the chart — instant time context',
      features: [
        "Tokyo/Asia, London/Europe, New York/US sessions",
        "Overlap highlighting; opacity control (0–10)",
        "Configurable times and colors (DST, instrument)"
      ]
    },
    // Asian Session Levels
    'asian-session-levels': {
      name: 'Asian Session Levels',
      description: 'Asian session references carried into the day — same frame for Europe and US',
      features: [
        "Key Asian-session levels (extremes and configurable references)",
        "Prior-session levels plotted on the current session",
        "Colors, times, labels, and session window adjustable"
      ]
    },
    // Enhanced Session Levels
    'enhanced-session-levels': {
      name: 'Enhanced Session Levels',
      description: 'IB, OR, session highs/lows and extensions — early-session structure at a glance',
      features: [
        "Automatic Initial Balance, Opening Range, and session extremes",
        "IB extensions from 100% to 600% (up to six levels)",
        "Zones, session times, premarket, colors, and optional prices — fully configurable"
      ]
    },
    // Risk/Reward
    'risk-reward': {
      name: 'Risk/Reward',
      description: 'Automatically calculate and visualize the risk/reward ratio of your trades with support for 3 Take Profit levels for advanced risk management',
      features: [
        "Support for 3 Take Profit levels (TP1, TP2, TP3) for progressive profit management",
        "Automatic calculation of risk/reward ratios for each level",
        "Complete customization of ratios, plots and colors",
        "Clear graphical visualization of entry, stop loss and take profit levels"
      ]
    },
    // Open Levels
    'open-levels': {
      name: 'Alturion Open Levels',
      description: 'Day/week/month opens plus past OHLC (up to 10 days/weeks, 12 months)',
      features: [
        "Current opens extended to the current bar",
        "OHLC 1–10 sessions/weeks, 1–12 months; optional extension",
        "Line styles, 0.5–5 px width, Gold & Platinum theme, stacked labels",
        "Five parameter groups, per-level toggles, SharpDX rendering"
      ]
    },
    // ORB
    'orb': {
      name: 'Alturion Open Range Breakout',
      description: 'Auto-drawn opening range, 100–300% extensions, breakout arrows',
      features: [
        "Range high, low, midpoint; configurable start/end and duration",
        "100%, 200%, 300% extensions; price labels",
        "Bull/bear arrows (visual aid); optional prior-session ranges",
        "Alturion palette colors, line styles and thickness"
      ]
    },
    'bar-timer': {
      name: 'Bar Timer',
      description: 'NinjaTrader bar countdown — readable close timing on the chart',
      features: [
        'Countdown to bar close',
        'Discreet, customizable display',
        'Compatible with NinjaTrader 8'
      ]
    },
    'nypa': {
      name: 'NYPA',
      description: 'Two prior-day US session liquidity zones — support/resistance and optional breakouts',
      features: [
        'Support and resistance zone identification',
        'Optional zone breakout indication',
        'Configurable alerts; US hours for your timezone'
      ]
    },
    'economic-calendar': {
      name: 'Economic Calendar',
      description: 'Built-in macro calendar — dedicated window and vertical lines at exact release times on the chart',
      features: [
        'Filters by period (today, tomorrow, week) and impact (stars)',
        'Vertical chart lines at each announcement time',
        'Configurable event colors and visibility'
      ]
    },
    'account-locker': {
      name: 'Account Locker',
      description: 'NT8 risk & PnL dashboard — rules, live PnL, peak, and built-in economic calendar',
      features: [
        'Rules: daily loss/profit, max trades, max lots, time windows',
        'Open-trade, day realized, and peak PnL (intraday drawdown)',
        'Manual lock (until next day or set duration) + built-in calendar'
      ]
    },
    'footprint': {
      name: 'Footprint',
      description: 'Tick-by-tick order flow — Bid×Ask, delta, imbalances, and per-bar profile',
      features: [
        'Bid×Ask, Delta, Volume, and Volume Profile modes',
        'Diagonal imbalances and stacked zones',
        'POC, Value Area, and per-bar delta stats'
      ]
    },
    'tape-power-meter': {
      name: 'Tape Power Meter',
      description: 'Measures tape buy/sell pressure to read flow in real time',
      features: [
        'Tape pressure reading',
        'Real-time imbalance visualization',
        'Parameters tuned for futures day trading'
      ]
    },
    'fair-value-gap': {
      name: 'Fair Value Gap',
      description: 'Automatic Fair Value Gap detection and tracking of unfilled zones',
      features: [
        'Automatic FVG detection',
        'Gap tracking until mitigation',
        'Clear display on the NT8 chart'
      ]
    },
    'cumulative-delta': {
      name: 'Cumulative Delta',
      description: 'Cumulative buy/sell flow to visualize imbalance over time',
      features: [
        'Session / period cumulative delta',
        'Buy/sell imbalance reading',
        'Customizable resets and colors'
      ]
    },
    'delta-profile': {
      name: 'Delta Profile',
      description: 'Delta distribution by price to see where flow truly fought',
      features: [
        'Delta profile by price level',
        'Highlights flow conflict zones',
        'Fits volume / order-flow analysis'
      ]
    },
    'big-trades': {
      name: 'Big Trades',
      description: 'Highlights large prints to spot institutional activity',
      features: [
        'Large-trade filtering by size',
        'Visual markers on the chart',
        'Instrument-tuned thresholds'
      ]
    }
  }
};

/**
 * Obtient la traduction d'un produit
 * @param {string} slug - Le slug du produit
 * @param {string} language - La langue (fr ou en)
 * @param {string} field - Le champ à traduire (name ou description)
 * @param {string} fallback - Valeur de fallback si traduction non trouvée
 * @returns {string} La traduction ou la valeur de fallback
 */
export const getProductTranslation = (slug, language, field, fallback) => {
  // Support des anciens slugs pour la rétrocompatibilité
  const slugMapping = {
    'volume-profile': 'volume-profile-premium',
    'vwap-avance': 'vwap-premium',
    'ny-price-action': 'nypa',
    'fun-bar-timer': 'bar-timer',
    'footprint-pro': 'footprint',
    'cumulative-delta-pro': 'cumulative-delta',
    'economic-news': 'economic-calendar'
  };

  // Utiliser le nouveau slug si disponible, sinon garder l'ancien
  const mappedSlug = slugMapping[slug] || slug;

  const translations = productTranslations[catalogLanguage(language)];
  if (translations && translations[mappedSlug] && translations[mappedSlug][field]) {
    return translations[mappedSlug][field];
  }
  return fallback;
};

/**
 * Traduit un produit complet
 * @param {Object} product - Le produit à traduire
 * @param {string} language - La langue (fr ou en)
 * @returns {Object} Le produit traduit
 */
export const translateProduct = (product, language) => {
  if (!product) {
    return product; // Retourne le produit original si produit invalide
  }

  // Support des anciens slugs pour la rétrocompatibilité
  const slugMapping = {
    'volume-profile': 'volume-profile-premium',
    'vwap-avance': 'vwap-premium',
    'ny-price-action': 'nypa',
    'fun-bar-timer': 'bar-timer',
    'footprint-pro': 'footprint',
    'cumulative-delta-pro': 'cumulative-delta',
    'economic-news': 'economic-calendar'
  };

  // Utiliser le nouveau slug si disponible, sinon garder l'ancien
  const mappedSlug = slugMapping[product.slug] || product.slug;

  const translations = productTranslations[catalogLanguage(language)];
  const productTranslation = translations && translations[mappedSlug];

  return {
    ...product,
    name: productTranslation?.name || product.name,
    description: productTranslation?.description || product.description,
    features: productTranslation?.features || product.features
  };
};